import React,{useState, useEffect} from 'react';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Joops(){

    const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
 <Sides/>
 <Helmet>
 
  <title>Java oops tutorial For Beginners</title>
<meta name="description" content="Java oops tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and questions of all technology like java tutorial, Java tutorial,Java tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java oops,java oops concepts,oops concepts in java
,oops in java,javascript oops,java oops interview questions,Object Oriented Programming Language in java,java oops concepts with examples,java oops principles,oops concepts in javascript,java oops concepts interview questions" />
<link rel="canonical" href="https://www.codeexampler.com/java-oops" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Oops Concepts in Java</h1>
    <div className="first">
        <a href="/java-array">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-class-and-object">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para">1, Object-Oriented Programming Language in java is a programming methodology, paradigm or style<br/>
2, Smalltalk is a first oops language. The first Smalltalk version published in the market in 1980<br/>
</p>
<h2 className="mt-4 mh2">There are 6 main oops concepts in java :
</h2>
<h3 className="mt-4 mh3">1, Class<br/>
2, Object and Method<br/>
3, Inheritance<br/>
4, Abstraction<br/>
5, Polymorphism<br/>
6, Encapsulation<br/>
</h3>



  <h1 className="mt-5">  </h1>
   
  <div className="back">
        <a href="/java-array">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-class-and-object">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Joops;